'use client';

export function getOrigin() {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
}
